<p
  id="sr-errors"
  class="sr-only"
  *ngIf="renderScreenreaderErrors && hasScreenreaderErrorMessages()"
>
  {{ screenreaderErrorMessages }}
</p>

<div
  class="alert alert-danger has-icon"
  aria-live="assertive"
  *ngIf="renderValidationSummary && hasErrors()"
>
  <span class="icon-warning"><span class="sr-only">Error</span></span>
  <p>Please note the following fields are required:</p>
  <p *ngFor="let error of errors">
    <strong>{{ error }}</strong>
  </p>
</div>
